import { useMemo } from 'react';
import { isAppModule } from '@src/utils/constants';
import { metricsStore } from '@globalStore/metricsStore';

export const EVENT_METRICS = {
  count: 'signal_count',
  with_user: 'users_with_signal',
  with_user_percentage: 'users_with_signal_percentage',
  with_session: 'sessions_with_signal',
  with_session_percentage: 'sessions_with_signal_percentage',
  without_user: 'users_without_signal',
  without_user_percentage: 'users_without_signal_percentage',
  without_session: 'sessions_without_signal',
  without_session_percentage: 'sessions_without_signal_percentage',
} as const;

export const EVENT_METRICS_LIST = [
  EVENT_METRICS.count,
  EVENT_METRICS.with_user,
  EVENT_METRICS.with_user_percentage,
  EVENT_METRICS.with_session,
  EVENT_METRICS.with_session_percentage,
  EVENT_METRICS.without_user,
  EVENT_METRICS.without_user_percentage,
  EVENT_METRICS.without_session,
  EVENT_METRICS.without_session_percentage,
] as const;

export interface EventMetaDefinitionEntry {
  identifier: string;
  type: string;
  output_order: number | null;
}

export interface EventMetadata {
  id: string;
  name: string;
  identifier: string;
  metrics: {
    count: string;
    users_with_signal: string;
    sessions_with_signal: string;
    users_without_signal: string;
    sessions_without_signal: string;
  };
  metaDefinition: EventMetaDefinitionEntry[];
}

export function useEventConfigs() {
  const eventConfigMeta = metricsStore((state) => state.eventConfigMeta);

  return useMemo<Record<string, EventMetadata>>(() => {
    if (isAppModule && eventConfigMeta) {
      return { ...eventConfigMeta };
    }
    return {};
  }, [eventConfigMeta]);
}

export function useEventList() {
  const configs = useEventConfigs();
  const eventConfigs = configs['signal_event'];
  return useMemo(() => {
    return Object.keys(eventConfigs.metrics);
  }, [eventConfigs.metrics]);
}
